import { gql } from '@apollo/client';

const EVENT_COUNTS_QUERY = gql`
  query eventCounts($studyIds: [ID]!) {
    eventCounts(studyIds: $studyIds) {
      isSuccess
      message
      eventCounts {
        study {
          id
          friendlyId
        }
        totalEvents
        openEvents
      }
    }
  }
`;

export default EVENT_COUNTS_QUERY;
